import { isPlainObject } from "@eroad/helpers/isPlainObject";

import type {
  DriverOptionsByAlt,
  DriverOptionsByLabel,
  DriverOptionsByPlaceholder,
  DriverOptionsByRole,
  DriverOptionsByText,
  DriverOptionsByTitle,
  DriverOptionsByValue,
} from "./types";

/**
 * Type guard for checking if a value is a value selector.
 */
function isAltSelector(selector: unknown): selector is DriverOptionsByAlt {
  if (isPlainObject(selector) && "alt" in selector) {
    return true;
  }

  return false;
}

/**
 * Type guard for checking if a value is a label selector.
 */
function isLabelSelector(selector: unknown): selector is DriverOptionsByLabel {
  if (isPlainObject(selector) && "label" in selector) {
    return true;
  }

  return false;
}

/**
 * Type guard for checking if a value is a placeholder selector.
 */
function isPlaceholderSelector(selector: unknown): selector is DriverOptionsByPlaceholder {
  if (isPlainObject(selector) && "placeholder" in selector) {
    return true;
  }

  return false;
}

/**
 * Type guard for checking if a value is a role selector.
 */
function isRoleSelector(selector: unknown): selector is DriverOptionsByRole {
  if (isPlainObject(selector) && "role" in selector) {
    return true;
  }

  return false;
}

/**
 * Type guard for checking if a value is a text selector.
 */
function isTextSelector(selector: unknown): selector is DriverOptionsByText {
  if (isPlainObject(selector) && "text" in selector) {
    return true;
  }

  return false;
}

/**
 * Type guard for checking if a value is a text selector.
 */
function isTitleSelector(selector: unknown): selector is DriverOptionsByTitle {
  if (isPlainObject(selector) && "title" in selector) {
    return true;
  }

  return false;
}

/**
 * Type guard for checking if a value is a value selector.
 */
function isValueSelector(selector: unknown): selector is DriverOptionsByValue {
  if (isPlainObject(selector) && "value" in selector) {
    return true;
  }

  return false;
}

export {
  isAltSelector,
  isLabelSelector,
  isPlaceholderSelector,
  isRoleSelector,
  isTextSelector,
  isTitleSelector,
  isValueSelector,
};
